import {
  CiSearch,
  CiCircleInfo,
  CiPower,
  CiFilter,
  CiImport,
  CiCirclePlus,
  CiCircleMinus,
} from "react-icons/ci";
import {
  IoEyeOutline,
  IoEyeOffOutline,
  IoPowerOutline,
  IoHomeOutline,
} from "react-icons/io5";
import { PiCopySimpleThin, PiMedalLight } from "react-icons/pi";
import {
  IoIosClose,
  IoMdCheckmark,
  IoMdCheckmarkCircleOutline,
  IoIosArrowDropdown,
  IoIosArrowDown,
  IoIosArrowUp,
} from "react-icons/io";
import { FaChevronLeft, FaAngleRight, FaArrowRight } from "react-icons/fa6";
import { GiCornerFlag, GiPartyPopper } from "react-icons/gi";
import { CiCalendar } from "react-icons/ci";
import {
  FiDollarSign,
  FiEdit2,
  FiUpload,
  FiKey,
  FiBriefcase,
  FiUsers,
} from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { AiOutlineMore } from "react-icons/ai";
import { BsPersonFillX, BsPersonFillCheck } from "react-icons/bs";
import { BiCalendarCheck, BiMenu } from "react-icons/bi";
import { MdApartment } from "react-icons/md";
import TermDataIcon from "./TermDataIcon";
import EventsIcon from "./EventIcon";
import EmployeeIcon from "./EmployeeIcon";
import RewardsIcon from "./RewardsIcon";
import ReportsIcon from "./ReportsIcon";
import FAQManagementIcon from "./FAQManagementIcon";

export let reactIcons = {
  dropdownDownArrow: IoIosArrowDropdown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  checkMarkIcon: IoMdCheckmark as React.FC<React.SVGProps<SVGSVGElement>>,
  leftIcon: FaChevronLeft as React.FC<React.SVGProps<SVGSVGElement>>,
  rightIcon: FaAngleRight as React.FC<React.SVGProps<SVGSVGElement>>,
  closeIcon: IoIosClose as React.FC<React.SVGProps<SVGSVGElement>>,
  ciPowerIcon: CiPower as React.FC<React.SVGProps<SVGSVGElement>>,
  copyIcon: PiCopySimpleThin as React.FC<React.SVGProps<SVGSVGElement>>,
  infoIcon: CiCircleInfo as React.FC<React.SVGProps<SVGSVGElement>>,
  searchIcon: CiSearch as React.FC<React.SVGProps<SVGSVGElement>>,
  visibilityOffIcon: IoEyeOffOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  visibilityOnIcon: IoEyeOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  FilterIcon: CiFilter as React.FC<React.SVGProps<SVGSVGElement>>,
  Flag: GiCornerFlag as React.FC<React.SVGProps<SVGSVGElement>>,
  calender: CiCalendar as React.FC<React.SVGProps<SVGSVGElement>>,
  dollar: FiDollarSign as React.FC<React.SVGProps<SVGSVGElement>>,
  edit: FiEdit2 as React.FC<React.SVGProps<SVGSVGElement>>,
  key: FiKey as React.FC<React.SVGProps<SVGSVGElement>>,
  checkMarkCircle: IoMdCheckmarkCircleOutline as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  delete: RiDeleteBinLine as React.FC<React.SVGProps<SVGSVGElement>>,
  upload: FiUpload as React.FC<React.SVGProps<SVGSVGElement>>,
  more: AiOutlineMore as React.FC<React.SVGProps<SVGSVGElement>>,
  activatePerson: BsPersonFillX as React.FC<React.SVGProps<SVGSVGElement>>,
  inActivatePerson: BsPersonFillCheck as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  export: CiImport as React.FC<React.SVGProps<SVGSVGElement>>,
  calendarCheck: BiCalendarCheck as React.FC<React.SVGProps<SVGSVGElement>>,
  terDataCalendrCheck: TermDataIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  eventIcon: EventsIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  employeeIcon: EmployeeIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  student: FiUsers as React.FC<React.SVGProps<SVGSVGElement>>,
  rewardsIcon: RewardsIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  reportsicon: ReportsIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  faqManagementIcon: FAQManagementIcon as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  department: FiBriefcase as React.FC<React.SVGProps<SVGSVGElement>>,
  accordianOpen: CiCirclePlus as React.FC<React.SVGProps<SVGSVGElement>>,
  accordianClose: CiCircleMinus as React.FC<React.SVGProps<SVGSVGElement>>,
  rightArrow: FaArrowRight as React.FC<React.SVGProps<SVGSVGElement>>,
  medal: PiMedalLight as React.FC<React.SVGProps<SVGSVGElement>>,
  menu: BiMenu as React.FC<React.SVGProps<SVGSVGElement>>,
  arrowDown: IoIosArrowDown as React.FC<React.SVGProps<SVGSVGElement>>,
  arrowUp: IoIosArrowUp as React.FC<React.SVGProps<SVGSVGElement>>,
  logout: IoPowerOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  home: IoHomeOutline as React.FC<React.SVGProps<SVGSVGElement>>,
};
